import { createContext, useContext, useState, useCallback } from "react";

const FiltersContext = createContext(null);

// Factores de variación por filtro — simulan distribución proporcional
export const FACTORES = {
  periodo: {
    "Mayo 2026": 0.42,
    "Abril 2026": 1.0,
    "Marzo 2026": 0.95,
    "Q1 2026": 2.85,
    "Q4 2025": 2.70,
    "Últimos 6 meses": 5.80,
    "Últimos 12 meses": 11.20,
  },
  centro: {
    "Todos los centros": 1.0,
    "CMSJ San Joaquín": 0.28,
    "Hospital Clínico UC": 0.35,
    "CM Lira": 0.12,
    "CM Escuela Militar": 0.08,
    "Clínica San Carlos de Apoquindo": 0.10,
    "CM Santa Lucía": 0.04,
    "CM Marcoleta": 0.03,
  },
  especialidad: {
    "Todas las especialidades": 1.0,
    "Medicina Familiar": 0.18,
    "Cardiología": 0.12,
    "Oftalmología": 0.11,
    "Pediatría": 0.09,
    "Ginecología y Obstetricia": 0.08,
    "Traumatología": 0.07,
    "Dermatología": 0.06,
    "Neurología": 0.05,
    "Endocrinología": 0.04,
    "Otorrinolaringología": 0.03,
    "Medicina General": 0.17,
  },
  prevision: {
    "Todas": 1.0,
    "FONASA": 0.45,
    "ISAPRE Colmena": 0.22,
    "ISAPRE Banmédica": 0.15,
    "ISAPRE Cruz Blanca": 0.10,
    "Particular": 0.08,
  },
};

/**
 * Aplica factores de variación multiplicativos sobre un valor base.
 * @param {number} base - Valor numérico original del mock
 * @param {object} filters - Objeto {periodo, centro, especialidad, prevision}
 * @returns {number} Valor ajustado (redondeado a entero)
 */
export function computeApplyFilters(base, filters) {
  if (base == null) return 0;
  const fp = FACTORES.periodo[filters.periodo] ?? 1.0;
  const fc = FACTORES.centro[filters.centro] ?? 1.0;
  const fe = FACTORES.especialidad[filters.especialidad] ?? 1.0;
  const fv = FACTORES.prevision[filters.prevision] ?? 1.0;
  return Math.round(base * fp * fc * fe * fv);
}

export function FiltersProvider({ children }) {
  const [filters, setFilters] = useState({
    periodo: "Mayo 2026",
    centro: "Todos los centros",
    especialidad: "Todas las especialidades",
    prevision: "Todas",
  });

  const applyFilters = useCallback(
    (base) => computeApplyFilters(base, filters),
    [filters]
  );

  return (
    <FiltersContext.Provider value={{ filters, setFilters, applyFilters }}>
      {children}
    </FiltersContext.Provider>
  );
}

export function useFilters() {
  const ctx = useContext(FiltersContext);
  if (!ctx) throw new Error("useFilters must be used inside FiltersProvider");
  return ctx;
}
